export default __webpack_public_path__ + "b62b032631728ae2629aa6e4ce39ebde.jpg";